<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-[25px] mb-[25px]"
  >
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client1.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            CodeCraft
          </span>
          <span class="block"> info@codecraft.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Olivia Taylor
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 555-5555
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            12
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@codecraft.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>

    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client2.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            ByteSavvy
          </span>
          <span class="block"> info@bytesavvy.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            David Smith
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 123-4567
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            16
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@bytesavvy.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client3.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            DataTech
          </span>
          <span class="block"> info@datatech.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Alice Johnson
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 234-5678
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            07
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@datatech.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client4.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            CyberByte
          </span>
          <span class="block"> info@cyberbyte.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Emily Brown
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 345-6789
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            05
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@cyberbyte.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client5.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            NetGen
          </span>
          <span class="block"> info@netgen.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            James Wilson
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 456-7890
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            14
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@netgen.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client6.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            TechFuse
          </span>
          <span class="block"> info@techfuse.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Michael Jones
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 567-8901
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            18
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@techfuse.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client7.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            CodeGen
          </span>
          <span class="block"> info@codegen.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Sophia Martinez
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 678-9012
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            34
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@codegen.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client8.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            WebWiz
          </span>
          <span class="block"> info@webwiz.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            William Davis
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 789-0123
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            08
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@webwiz.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client9.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            ByteTech
          </span>
          <span class="block"> info@bytetech.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Ava Anderson
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 890-1234
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            03
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@bytetech.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client10.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            CloudFlex
          </span>
          <span class="block"> info@cloudflex.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Ethan Thomas
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 901-2345
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            10
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@cloudflex.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client11.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            WebWorx
          </span>
          <span class="block"> info@webworx.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Isabella Clark
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 012-3456
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            25
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@webworx.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content relative -mt-[7px]">
        <div
          class="absolute -top-[18px] ltr:-left-[20px] rtl:-right-[20px] ltr:md:-left-[25px] rtl:md:-right-[25px] w-[90px] bg-gray-50 dark:bg-[#0a0e19] border-b-[10px] ltr:border-r-[10px] rtl:border-l-[10px] border-gray-50 dark:border-[#0a0e19] ltr:rounded-br-md rtl:rounded-bl-md"
        >
          <img
            src="@/assets/images/clients/client12.jpg"
            alt="client-image"
            class="rounded-md"
          />
        </div>
        <div class="mb-[20px] md:mb-[25px] ltr:pl-[88px] rtl:pr-[88px]">
          <span
            class="font-medium text-black dark:text-white block text-md mb-[2px]"
          >
            TechSync
          </span>
          <span class="block"> info@techsync.com </span>
        </div>
        <ul>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Name:
            </span>
            Alexander Lewis
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Phone:
            </span>
            (555) 210-9876
          </li>
          <li class="text-black dark:text-white font-medium mb-[5px] last:mb-0">
            <span
              class="ltr:mr-[7px] rtl:ml-[7px] text-gray-500 dark:text-gray-400 font-normal"
            >
              Projects:
            </span>
            15
          </li>
        </ul>
        <div class="mt-[17px]">
          <a
            href="mailto:info@techsync.com"
            class="inline-block rounded-md font-medium border border-primary-500 text-white bg-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-400 hover:border-primary-400 ltr:mr-[10px] rtl:ml-[10px]"
          >
            Message
          </a>
          <a
            href="javascript:void(0);"
            class="inline-block rounded-md font-medium border border-primary-500 text-primary-500 py-[4.5px] px-[15.5px] transition-all hover:bg-primary-500 hover:text-white"
          >
            View Project
          </a>
        </div>
      </div>
    </div>
  </div>

  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <Pagination items="12" total="36" class="pt-[0] md:pt-[0]" />
    </div>
  </div>
</template>

<script lang="ts">
import Pagination from "@/components/Common/Pagination.vue";
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Clients",
  components: {
    Pagination,
  },
});
</script>

<style lang="scss" scoped>
@media (min-width: 768px) {
  .md\:pt-\[0\] {
    padding-top: 0 !important;
  }
}
.pt-\[0\] {
  padding-top: 0 !important;
}
</style>
